// extracted by mini-css-extract-plugin
export default {"title":"PaymentToWholesalerDetails_title__JRafZ","total":"PaymentToWholesalerDetails_total__EjnaU","pay":"PaymentToWholesalerDetails_pay__C3ZSp"};